import React from "react";
import ModalSlider from "./ModalSlider";
import PropTypes from "prop-types";
import i18n from "../i18n";
import {hitEvent, hits, logEvent, userEvents} from "../utils/log";
import * as webviewUtils from "../utils/webview";
import clientStorage from "../utils/client-storage";
import ProcessingButton from "../components/ProcessingButton/ProcessingButton";
import {SliderContainerStyled} from "../pages/result/ResultPage.style";
import {Swiper, SwiperSlide} from "swiper/react";
import {runOnceByLocalStorage} from "../utils/etc";
import processingManager from "../photolab/ProcessingManager";
import ProcessingLoader from "./ProcessingLoader/ProcessingLoader";
import {extraKeys} from "../photolab/etc";
// import {EffectCards} from "swiper";

export default class ShareModal extends ModalSlider {
  state = {
    copied: false,
    updatedAt: 0,
  }

  componentDidMount() {
    processingManager.addOnProcessingChangeHandler(this.handleProcessingChange);

    window.webviewEventsListeners.backPress.push(() => {
      this.dismiss();
      return true;
    });

    if (window.clientConfig.features.showVideo) {
      runOnceByLocalStorage("show_share_modal", () => {
        this.props.onCreateAnimation(true);
      });
    }
  }

  componentWillUnmount() {
    processingManager.removeOnProcessingChangeHandler(this.handleProcessingChange);
  }

  dismiss(trigger) {
    const animatedCreative = processingManager.processing.creatives
      .find((c) => c.group === "video" && c.getExtra("source_id") === this.props.creative.id);
    const isShowNotification = animatedCreative && animatedCreative.isPending ? true : false;
    this.props.onClose && this.props.onClose(isShowNotification, this.props.creativeIndex);

    window.webviewEventsListeners.backPress.pop();
    super.dismiss(trigger);
  }

  handleProcessingChange = () => {
    this.setState({
      updatedAt: Date.now(),
    });
  }

  handleCloseButtonClick = (e) => {
    const sessionIdx = parseInt(window.clientConfig.webviewParams["session_idx"] || 1);

    const isShowRateApp = window.clientConfig.isWebview
      && sessionIdx !== clientStorage.getRateAppSessionIdx();

    if (isShowRateApp) {
      hitEvent(hits.RATEAPP_DIALOG_SHOW);
      logEvent(userEvents.RATEAPP_DIALOG_SHOW);

      clientStorage.setRateAppSessionIdx(sessionIdx);

      webviewUtils.webviewRateApp((res) => {
        switch (parseInt(res)) {
          case 0: hitEvent(hits.RATEAPP_DIALOG_INAPP_RESPONSE_0); return;
          case 1: hitEvent(hits.RATEAPP_DIALOG_INAPP_RESPONSE_1); return;
          case 2: hitEvent(hits.RATEAPP_DIALOG_INAPP_RESPONSE_2); return;
          case 3: hitEvent(hits.RATEAPP_DIALOG_INAPP_RESPONSE_3); return;
          default:
            return;
        }
      });
    }

    this.dismiss();
  }

  handleCopyButtonClick = () => {
    if (!this.state.copied) {
      navigator.clipboard.writeText(this.props.hashtag);
      this.setState({copied: true});
    }
  }

  renderModal() {
    const animatedCreative = processingManager.processing.creatives
      .find((c) => c.group === "video" && c.getExtra("source_id") === this.props.creative.id);
    const collageWithVideo = window.clientConfig.features.collageWithAnimation
      && this.props.creative.getExtra(extraKeys.collageType) === "video";

    return <SliderContainerStyled isWeb={window.clientConfig.isWeb ? 1 : 0} style={{width: this.props.slider.width}}>
      <Swiper
        centeredSlides={true}
        spaceBetween={10}
        initialSlide={this.props.initialSlide ? this.props.initialSlide : 0}
        slidesPerView={window.clientConfig.isWebDesktop ? 1 : 1.12}
        onSwiper={(swiper) => this.swiperRef = swiper}>
        <SwiperSlide
          className="share-slide"
          style={{height: this.props.slider.height < 318 ? "100%" : this.props.slider.height}}
        >
          <div className="share-slide__top">
            <button
              className="button-close-popup"
              onClick={this.handleCloseButtonClick}>
              <svg viewBox="0 0 16 16">
                <path strokeWidth=".5" d="M.554 2.025L6.53 8 .554 13.976c-.405.405-.405 1.064 0 1.47.406.405 1.065.405 1.47 0L8 9.47l5.975 5.975c.406.406 1.065.406 1.47 0h0c.406-.405.406-1.064 0-1.47L9.47 8l5.976-5.976h0c.405-.405.405-1.064 0-1.47-.406-.405-1.065-.405-1.47 0 0 0 0 0 0 0L8 6.53 2.024.554C1.62.15.96.15.554.554.15.96.148 1.62.554 2.024c0 0 0 0 0 0z" />
              </svg>
            </button>
            <h1 dangerouslySetInnerHTML={{__html: i18n.t("share_modal__title")}} />
            <p className="share-modal-text-1" dangerouslySetInnerHTML={{__html: i18n.t("share_modal__text_1")}} />
            <p className="share-modal-text-2" dangerouslySetInnerHTML={{__html: i18n.t("share_modal__text_2")}} />

            <div className="copy-container">
              <p>{this.props.hashtag}</p>
              <button
                onClick={this.handleCopyButtonClick}>
                {!this.state.copied && <>
                  <svg viewBox="0 0 15 15" fill="none">
                    <g clipPath="url(#r0mu89jzpa)" strokeWidth="1.2" strokeLinejoin="round">
                      <path d="M11.924 3.75H5.42a1.67 1.67 0 0 0-1.67 1.67v6.504c0 .922.748 1.67 1.67 1.67h6.504a1.67 1.67 0 0 0 1.67-1.67V5.42a1.67 1.67 0 0 0-1.67-1.67z" />
                      <path d="m11.235 3.75.015-.703a1.645 1.645 0 0 0-1.64-1.64H3.28A1.88 1.88 0 0 0 1.406 3.28V9.61a1.645 1.645 0 0 0 1.64 1.641h.704" strokeLinecap="round" />
                    </g>
                    <defs>
                      <clipPath id="r0mu89jzpa">
                        <path fill="#fff" d="M0 0h15v15H0z" />
                      </clipPath>
                    </defs>
                  </svg>
                  {i18n.t("share_modal__copy")}
                </>}

                {this.state.copied && <>
                  <svg viewBox="0 0 15 15" fill="none">
                    <path d="m3.125 8.125 2.5 2.5 6.25-6.25" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  {i18n.t("share_modal__copied")}
                </>}
              </button>
            </div>

            {Object.values(this.props.providers).filter(Boolean).length > 0 && <div className="btns-container">
              {Object.keys(this.props.providers).map((provider) => <button
                key={provider}
                hidden={!this.props.providers[provider]}
                className={"btn-" + provider}
                onClick={() => this.props.onShare(provider, this.props.creative)}
              />)}
            </div>}
          </div>
          {window.clientConfig.features.showVideo && !animatedCreative && <ProcessingButton
            text={i18n.t(collageWithVideo ? "share_modal__create_animation" : "share_modal__create_collage")}
            onClick={() => this.props.onCreateAnimation(false)}
          />}

          {animatedCreative && animatedCreative.isPending && <ProcessingButton
            creative={animatedCreative}
            progressPercent={this.state.progressPercent}
            text={i18n.t(collageWithVideo ? "share_modal__creating_animation" : "share_modal__creating_collage")}
            onClick={() => {this.swiperRef.slideNext();}}
          />}

          {animatedCreative && animatedCreative.isFinished && <ProcessingButton
            creative={animatedCreative}
            text={i18n.t(collageWithVideo ? "share_modal__watch_video" : "share_modal__watch_collage")}
            onClick={() => {this.swiperRef.slideNext();}}
          />}
        </SwiperSlide>
        {animatedCreative && <SwiperSlide
          style={{height: this.props.slider.height + 100}}
        >
          <div className="share-slide__result" style={{height: this.props.slider.height}}>
            {animatedCreative && animatedCreative.isFailed && <ProcessingButton
              text={i18n.t("retry")}
              onClick={() => this.props.onRetryCreative(animatedCreative)}
            />}
            <button
              className="button-close-popup bg"
              onClick={this.handleCloseButtonClick}>
              <svg viewBox="0 0 16 16">
                <path strokeWidth=".5" d="M.554 2.025L6.53 8 .554 13.976c-.405.405-.405 1.064 0 1.47.406.405 1.065.405 1.47 0L8 9.47l5.975 5.975c.406.406 1.065.406 1.47 0h0c.406-.405.406-1.064 0-1.47L9.47 8l5.976-5.976h0c.405-.405.405-1.064 0-1.47-.406-.405-1.065-.405-1.47 0 0 0 0 0 0 0L8 6.53 2.024.554C1.62.15.96.15.554.554.15.96.148 1.62.554 2.024c0 0 0 0 0 0z" />
              </svg>
            </button>
            <ProcessingLoader
              creative={animatedCreative}
              imagesUrls={["/assets/images/icon-fire.png"]}
              contain={1}
              processingTookSecondsApprox={20}
              texts={[
                collageWithVideo ? "share_modal__creating_animation_dots" : "share_modal__creating_collage_dots",
              ]}
              stroke="rgb(5, 19, 32)"
            />
            {animatedCreative && animatedCreative.isProcessed && (collageWithVideo ?
              <video
                autoPlay
                loop
                controls={false}
                muted
                playsInline
                preload="auto">
                <source src={animatedCreative.result} type="video/mp4" />
              </video>
              :
              <img src={animatedCreative.result} alt="" />
            )}
          </div>
          {animatedCreative && animatedCreative.isProcessed && <div className="btns-container pb-none">
            <button
              className="btn-save"
              onClick={() => this.props.onShare("save", animatedCreative)} />
            {Object.keys(this.props.providers).map((provider) => <button
              key={provider}
              hidden={!this.props.providers[provider]}
              className={"btn-" + provider}
              onClick={() => this.props.onShare(provider, animatedCreative)}
            />)}
          </div>}
        </SwiperSlide>}
      </Swiper>
    </SliderContainerStyled>
  }
}

ShareModal.propTypes = {
  onShare: PropTypes.func.isRequired,
  hashtag: PropTypes.string,
  providers: PropTypes.object,
};
